import { render, staticRenderFns } from "./QueryFormView.vue?vue&type=template&id=60e71242&scoped=true"
import script from "./QueryFormView.vue?vue&type=script&lang=js"
export * from "./QueryFormView.vue?vue&type=script&lang=js"
import style0 from "./QueryFormView.vue?vue&type=style&index=0&id=60e71242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e71242",
  null
  
)

export default component.exports